import _defineProperty from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "className", "dark", "size", "selected", "selectedIcon", "defaultIcon", "iconSize", "onSelect", "onClick", "eventKey", "withHoverBg"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import classNames from 'classnames';
import React from 'react';
import { Icons } from '../icons/icons';
import { LinkBase } from './link-base/link-base';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var Selectable = function Selectable(_ref) {
  var children = _ref.children,
      className = _ref.className,
      dark = _ref.dark,
      size = _ref.size,
      selected = _ref.selected,
      selectedIcon = _ref.selectedIcon,
      defaultIcon = _ref.defaultIcon,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? 'inherit' : _ref$iconSize,
      onSelect = _ref.onSelect,
      _onClick = _ref.onClick,
      eventKey = _ref.eventKey,
      _ref$withHoverBg = _ref.withHoverBg,
      withHoverBg = _ref$withHoverBg === void 0 ? true : _ref$withHoverBg,
      rest = _objectWithoutProperties(_ref, _excluded);

  var StateIcon = Icons === null || Icons === void 0 ? void 0 : Icons["".concat(selected ? selectedIcon : defaultIcon)];
  return /*#__PURE__*/_jsxs(LinkBase, _objectSpread(_objectSpread({
    variant: "selectable",
    target: "_self",
    className: classNames(className, {
      'link-selectable-dark': dark,
      'link-selectable-selected': selected
    }),
    onClick: function onClick(event) {
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(eventKey);
      _onClick === null || _onClick === void 0 ? void 0 : _onClick(event);
    }
    /**
     * Disable the default hover background if the component
     * is dark or the user has explicitly disabled it otherwise
     * the dark themed background will not be visible.
     */
    ,
    withHoverBg: !dark && withHoverBg,
    size: size
  }, rest), {}, {
    children: [children, StateIcon && /*#__PURE__*/_jsx(StateIcon, {
      size: iconSize
    })]
  }));
};